"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var createEmptyDocument_1 = __importDefault(require("../createEmptyDocument"));
function createNoteDocument(type) {
    if (type === void 0) { type = 'note'; }
    return {
        type: type,
        title: '',
        content: createEmptyDocument_1.default(),
        category: null,
        subcategories: [],
        cards: [],
    };
}
exports.default = createNoteDocument;
//# sourceMappingURL=createNoteDocument.js.map